<p-toast position="top-right"></p-toast>

<!-- F-009 · Aviso de documentos aprobados del cliente que el arrendamiento todavía no tiene (solo con leases.update) -->
<ng-container *ngIf="canCopy">
  <div class="copy-notice is-muted" *ngIf="previewLoading && !preview" role="status">
    <i class="fa-solid fa-spinner fa-spin"></i>
    <span class="notice-text">Revisando el expediente del cliente…</span>
  </div>

  <div class="copy-notice is-error" *ngIf="previewError && !previewLoading && !dialogVisible" role="alert">
    <i class="fa-solid fa-triangle-exclamation"></i>
    <span class="notice-text">No se pudo revisar si el cliente tiene documentos nuevos.</span>
    <button pButton type="button" class="p-button-text p-button-sm" label="Reintentar" (click)="loadPreview()"></button>
  </div>

  <div class="copy-notice" *ngIf="pendingToCopy > 0 && !previewError">
    <i class="fa-solid fa-circle-info"></i>
    <div class="notice-text">
      <strong>{{ pendingLabel }}</strong>
      <span>El expediente del cliente tiene archivos aprobados que este arrendamiento no tiene.</span>
    </div>
    <button
      pButton
      type="button"
      class="p-button-sm p-button-outlined"
      icon="fa-solid fa-copy"
      label="Revisar y copiar"
      (click)="openDialog()"
    ></button>
  </div>

  <div class="copy-notice is-muted" *ngIf="preview && !preview.canCopy && preview.message">
    <i class="fa-solid fa-lock"></i>
    <span class="notice-text">{{ preview.message }}</span>
  </div>
</ng-container>

<app-customer-documents
  *ngIf="leaseDetailService.data"
  mode="lease-readonly"
  [docsEntity]="leaseDetailService.data.documents"
  [entityType]="leaseDetailService.data.documentType"
  [ownerRfc]="leaseDetailService.data.client?.rfc"
></app-customer-documents>

<p-dialog
  [(visible)]="dialogVisible"
  header="Copiar documentos del cliente"
  styleClass="lease-copy-docs-dialog"
  appendTo="body"
  [modal]="true"
  [closable]="!copying"
  [closeOnEscape]="!copying"
  [dismissableMask]="!copying"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '640px' }"
  [breakpoints]="{ '768px': '96vw' }"
>
  <p class="dialog-intro">
    Marca los archivos aprobados del expediente del cliente que quieres copiar a este arrendamiento. Lo que el arrendamiento ya tiene no se
    borra ni se reemplaza.
  </p>
  <p class="dialog-note" *ngIf="excludedNote"><i class="fa-solid fa-hourglass-half"></i> {{ excludedNote }}</p>

  <div class="copy-loading" *ngIf="previewLoading; else previewReady" role="status">
    <p-skeleton height="1.1rem" width="40%" styleClass="mb-3"></p-skeleton>
    <p-skeleton height="2.4rem" styleClass="mb-2"></p-skeleton>
    <p-skeleton height="2.4rem" styleClass="mb-2"></p-skeleton>
    <p-skeleton height="2.4rem"></p-skeleton>
  </div>

  <ng-template #previewReady>
    <div class="empty-state" *ngIf="previewError">
      <i class="fa-solid fa-triangle-exclamation"></i>
      <h3>No se pudo cargar el expediente del cliente</h3>
      <button pButton type="button" class="p-button-sm p-button-outlined" label="Reintentar" (click)="loadPreview(true)"></button>
    </div>

    <div class="empty-state" *ngIf="!previewError && !groups.length">
      <i class="fa-solid fa-folder-open"></i>
      <h3>No hay archivos aprobados para copiar</h3>
    </div>

    <div class="copy-unit" *ngFor="let unit of groups; let gi = index">
      <div class="unit-head">
        <i class="fa-solid" [ngClass]="unit.key === 'holder' ? 'fa-user' : 'fa-user-shield'"></i>
        <span class="unit-title">{{ unit.title }}</span>
        <p-tag *ngIf="unit.newInLease" severity="info" icon="pi pi-plus-circle" value="Nuevo en el arrendamiento"></p-tag>
      </div>

      <div class="copy-section" *ngFor="let section of unit.sections; let si = index">
        <div class="section-label">{{ section.label }}</div>
        <div class="file-row" *ngFor="let row of section.rows; let fi = index" [class.is-copied]="row.candidate.isAlreadyInLease">
          <p-checkbox
            [binary]="true"
            [inputId]="'copy-file-' + gi + '-' + si + '-' + fi"
            [ngModel]="row.candidate.isAlreadyInLease || isSelected(row.candidate)"
            [disabled]="row.candidate.isAlreadyInLease || copying"
            (onChange)="toggle(row.candidate)"
          ></p-checkbox>
          <label class="file-info" [for]="'copy-file-' + gi + '-' + si + '-' + fi">
            <span class="file-field">{{ row.fieldLabel }}</span>
            <span class="file-name" [title]="row.fileName">{{ row.fileName }}</span>
          </label>
          <span class="file-date" *ngIf="row.candidate.uploadedAt">{{ row.candidate.uploadedAt | date: 'dd/MM/yyyy' }}</span>
          <p-tag *ngIf="row.candidate.isAlreadyInLease" severity="success" icon="pi pi-check" value="Ya copiado"></p-tag>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" label="Cancelar" [disabled]="copying" (click)="dialogVisible = false"></button>
    <button
      pButton
      type="button"
      icon="fa-solid fa-copy"
      [label]="'Copiar (' + selectedCount + ')'"
      [loading]="copying"
      [disabled]="selectedCount === 0 || copying || previewLoading"
      (click)="copy()"
    ></button>
  </ng-template>
</p-dialog>
